import { Injectable, Injector } from '@angular/core';

import { CrudService, Filter } from '@mango/core';
import { FactuurStatusHistorie } from '../dto/factuurStatusHistorie';

@Injectable({ providedIn: 'root' })
export class FactuurStatusHistorieService extends CrudService<FactuurStatusHistorie> {

    constructor(injector: Injector) { super(FactuurStatusHistorie, injector); }

    getFactuurFilter(factuurId: number): Filter<FactuurStatusHistorie> {
        return new Filter<FactuurStatusHistorie>(fb => [fb.equal(x => x.factuur.id, factuurId)]);
    }

}
